import React, { useEffect, useState } from "react";
import defaultImage from "../../assets/images/users/mobile-app.png";
import styled from "styled-components";
import PropTypes from "prop-types";
import { Col, FormGroup, Label, Row } from "reactstrap";
import { AvField } from "availity-reactstrap-validation";
import { connect } from "react-redux";
import "flatpickr/dist/themes/material_blue.css";
import { getAppData } from "../../store/apps/actions";
import { withRouter } from "react-router-dom";
import Select from "react-select";

const ApplicationForm = props => {
  const [app_name, setAppName] = useState("");
  const [app_link, setAppLink] = useState("");

  useEffect(() => {
    return () => {
      setAppName("");
    };
  }, []);

  useEffect(() => {
    setAppName(prev => {
      if (props.app_data?.title != prev) {
        return props.app_data?.title;
      } else if (props.app?.name) {
        return props.app?.name;
      }
    });
  }, [props.app_data, props.app]);

  const handleLoadAppData = link => {
    props.getAppData(link);
    setAppLink(link);
  };

  const can_editable =
    (props.type === "edit" &&
      props.permissions["change_clientapplicationmodel"]) ||
    (props.type !== "edit" && props.permissions["add_clientapplicationmodel"]);

  return (
    <>
      <StyledRow className="d-flex justify-content-center">
        <Col sm={12}>
          <Row className="align-items-center">
            {/* <Col md={12} className={props.type != "edit" ? "d-none" : ""}>
              <button
                type="button"
                onClick={() =>
                  can_editable &&
                  props.changeStatusApp(
                    props.app_data?.title || props.app?.name,
                    props.app?.is_active
                  )
                }
                disabled={!can_editable}
                className={`btn ${
                  props.app?.is_active ? "btn-success" : "btn-warning"
                } waves-effect btn-label waves-light mb-3`}
              >
                <i
                  className={`bx ${
                    props.app?.is_active ? "bx-check" : "bx-block"
                  } label-icon`}
                />
                App is {props.app?.is_active ? "active" : "inactive"}
              </button>
            </Col> */}
            <Col md={12} align="center">
              {props.loading ? (
                <Logotype className="avatar-lg profile-user-wid w-100 d-flex align-items-center justify-content-center">
                  <div
                    className="spinner-border text-primary m-1"
                    role="status"
                  />
                </Logotype>
              ) : (
                <Logotype className="avatar-lg profile-user-wid w-100 d-flex align-items-center justify-content-center">
                  <img
                    src={
                      props.app_data !== null &&
                        props.app_data.img !== undefined
                        ? props.app_data.img
                        : props.app?.app_picture || defaultImage
                    }
                    alt=""
                    style={{
                      maxHeight: "100%",
                    }}
                    className="img-thumbnail rounded-circle"
                    crossOrigin="Anonymous"
                  />
                </Logotype>
              )}
              <FormGroup>
                <AvField
                  name="app_picture"
                  className="form-control d-none"
                  id="app_picture"
                  // onChange={e => setAppName(e.target.value)}
                  value={
                    props.app_data !== null && props.app_data.img !== undefined
                      ? props.app_data.img
                      : props.app?.app_picture
                  }
                  readOnly
                />
              </FormGroup>
            </Col>
            <Col md={12}>
              <Row>
                <Col md={6}>
                  <Label htmlFor="formrow-password-Input">
                    Link to the app
                  </Label>
                  <FormGroup>
                    <AvField
                      name="app_link"
                      type="text"
                      value={props.app?.link || ""}
                      onChange={e => setAppLink(e.target.value)}
                      onBlur={e =>
                        can_editable && handleLoadAppData(e.target.value)
                      }
                      disabled={
                        !can_editable ||
                        (props.type === "edit" && !props.app?.is_active)
                      }
                      style={{
                        backgroundColor: "white !important",
                      }}
                      validate={{
                        required: { value: true },
                        minLength: {
                          value: 5,
                          errorMessage: "Please enter valid link",
                        },
                        maxLength: {
                          value: 255,
                        },
                      }}
                    />
                  </FormGroup>
                </Col>
                <Col md={6}>
                  <Label htmlFor="formrow-email-Input">Application name</Label>
                  <FormGroup>
                    <AvField
                      name="app_name"
                      className="form-control"
                      id="formrow-email-Input"
                      value={props.app_data?.title || props.app?.name}
                      readOnly
                      // !can_editable || (props.type === "edit" && !props.app?.is_active)
                      disabled
                      date={{
                        required: { value: true },
                        minLength: {
                          value: 3,
                          errorMessage: "Missing application name",
                        },
                        maxLength: {
                          value: 255,
                        },
                      }}
                    />
                  </FormGroup>
                </Col>
              </Row>
            </Col>
          </Row>
          <>
            <Row>
              <Col sm="12">
                <Label
                  htmlFor="formrow-password-Input"
                // style={{ marginTop: "25px" }}
                >
                  {/* Tracking platform */}
                </Label>
              </Col>
            </Row>
            <Row className="mt-10">
              <Col className="mt-10">
                {/* {rowTracker.length !== 0 ? ( */}
                {/* rowTracker.map((item, idx) => ( */}
                <Row className="inner mb-4">
                  <Col md={6} className="d-flex" style={{ marginBottom: 27 }}>
                    {/* {can_editable && (
                      <Button
                        onClick={e => handleRemoveRow(item.id)}
                        color="danger"
                        className="btn-block inner me-3 d-none"
                        style={{
                          height: "38px",
                        }}
                      >
                        <i className="mdi mdi-trash-can font-size-16" />
                      </Button>
                    )} */}
                    <StyledForm className="flex-grow-1">
                      <Label htmlFor="formrow-email-Input">
                        Tracking platform
                      </Label>
                      <Select
                        name={`platform`}
                        defaultValue={props.selectedTracker}
                        options={props.tracking_platforms}
                        isDisabled={
                          !can_editable ||
                          (props.type === "edit" && !props.app?.is_active)
                        }
                        classNamePrefix="select2-selection"
                        errorMessage="Tracking platform field is required"
                        onChange={props.setSelectedTracker}
                      />
                    </StyledForm>
                  </Col>
                  {props.selectedTracker?.value == "ADJUST" && (
                    <Col md={6} className="">
                      <FormGroup style={{ marginTop: "25px" }}>
                        <AvField
                          style={{
                            height: "38px",
                          }}
                          name={`general_token`}
                          type="text"
                          value={props.app?.general_token || ""}
                          placeholder="General token..."
                          disabled={
                            !can_editable ||
                            (props.type === "edit" && !props.app?.is_active)
                          }
                          validate={{
                            required: {
                              value: true,
                            },
                            minLength: {
                              value: 1,
                              errorMessage: "Please enter valid token",
                            },
                            maxLength: {
                              value: 350,
                              errorMessage: "The token is so long",
                            },
                          }}
                        // onChange={e =>
                        //   handleChangeGeneralToken(e.target, idx)
                        // }
                        />
                      </FormGroup>
                    </Col>
                  )}
                  <Col md={6} className="d-flex">
                    <StyledForm className="flex-grow-1">
                      <Label htmlFor="formrow-email-Input">
                        Dashboard type
                      </Label>
                      <Select
                        name={`dashboard_type`}
                        defaultValue={props.selectDashboard}
                        options={props.dashboardTypes}
                        classNamePrefix="select2-selection"
                        errorMessage="Tracking platform field is required"
                        onChange={props.setSelectDashboard}
                      />
                    </StyledForm>
                  </Col>
                  {props.selectedTracker?.value == "ADJUST" && (
                    <Col md={6} className="d-flex">
                      <StyledForm className="flex-grow-1">
                        <Label htmlFor="formrow-email-Input">
                          Attribution source
                        </Label>
                        <Select
                          name={`attribution_type`}
                          defaultValue={props.selectAttrType}
                          options={props.attributionTypes}
                          classNamePrefix="select2-selection"
                          errorMessage="Attribution source field is required"
                          onChange={props.setSelectAttrType}
                        />
                      </StyledForm>
                    </Col>
                  )}
                  {props.selectedTracker?.value == "ADJUST" && (
                    <>
                      <Row>
                        <Col sm="12">
                          <Label
                            htmlFor="formrow"
                          >
                            {/* Field for padding */}
                          </Label>
                        </Col>
                      </Row>
                      <Col md={6} className="d-flex">
                        <StyledForm className="flex-grow-1">
                          <Label htmlFor="formrow-accountID-Input">
                            Account ID
                          </Label>
                          <AvField
                            name="account_id"
                            className="form-control"
                            type="number"
                            placeholder="Account ID..."
                            id="formrow-accountID-Input"
                            value={props.app_data?.account_id || props.app?.account_id}
                            date={{
                              required: {
                                value: true
                              }
                            }}
                          />
                        </StyledForm>
                      </Col>
                    </>
                  )}
                </Row>
              </Col>
            </Row>
          </>
        </Col>
      </StyledRow>
    </>
  );
};

const StyledRow = styled(Row)`
  .form-control:disabled {
    /* color: hsl(0, 0%, 60%); */
    background-color: #eff2f7;
    opacity: 1;
  }
`;

const StyledForm = styled(FormGroup)`
  .select2-selection--is-disabled {
    .select2-selection__control {
      &.select2-selection__control--is-disabled {
        background: #eff2f7 !important;
      }
    }
  }
`;

const Logotype = styled.div`
  margin-top: 0px;
  margin-bottom: 30px;
`;

ApplicationForm.propTypes = {
  match: PropTypes.object,
  app_data: PropTypes.any,
  tracking_platforms: PropTypes.any,
  loading: PropTypes.bool,
  getAppData: PropTypes.func,
  onSubmitForm: PropTypes.func,
  app: PropTypes.any,
  type: PropTypes.string,
  changeStatusApp: PropTypes.func,
  permissions: PropTypes.any,
  setSelectedTracker: PropTypes.func,
  selectedTracker: PropTypes.any,
  dashboardTypes: PropTypes.array,
  setSelectDashboard: PropTypes.func,
  selectDashboard: PropTypes.any,
  attributionTypes: PropTypes.any,
  setSelectAttrType: PropTypes.func,
  selectAttrType: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.Apps.loading,
  permissions: state.User.permissions,
});

export default connect(mapStateToProps, {
  getAppData,
})(withRouter(ApplicationForm));
